import './App.css';
import Navbar from './compounts/Navbar';
import Footer from './compounts/Footer';
import Login from './compounts/Login';
import Home from './compounts/Home';
import { Routes, Route } from 'react-router-dom';
import PetGrooming from './compounts/PetGrooming';
import PetBoarding from './compounts/PetBoarding';
import DogWalking from './compounts/DogWalking';
import Vetpart from './compounts/Vetpart';
import Adoptapet from './compounts/Adoptapet';
import Dogtraning from './compounts/Dogtraning';
import ShopNavbar from './compounts/ShopNavbar';
import SignUpForm from './compounts/SignUpForm';

function App() {
  return (
    <div>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<SignUpForm />} />
        <Route path="grooming" element={<PetGrooming />} />
        <Route path="boarding" element={<PetBoarding />} />
        <Route path="walking" element={<DogWalking />} />
        <Route path="vet" element={<Vetpart />} />
        <Route path="adopt" element={<Adoptapet />} />
        <Route path="training" element={<Dogtraning />} />
        <Route path="shop" element={<ShopNavbar />} />
      </Routes>
      <Footer />

    </div>
  );
}

export default App;
